<ng-container *transloco="let t">
    <a
        vds-icon-button
        [loading]="loading()"
        appearance="ghost"
        mode="dark"
        [vdsTooltip]="t('notificationsArea')"
        placement="bottom"
        [routerLink]="[]"
        [queryParams]="{ sb: true }"
        ampRouterEvent
        ampEventContext="Announcement area"
        queryParamsHandling="merge"
    >
        <vds-icon name="bullhorn" />
        @if (unreadNotifications()) {
            <vds-status-dot class="animate-ping" size="s" style="--vds-status-dot-color: var(--vds-color-blue-200)" />
            <vds-status-dot size="s" style="--vds-status-dot-color: var(--vds-color-blue-400)" />
        }
    </a>
</ng-container>
